import React from "react";
import { Sparkles, ArrowRight } from "lucide-react";

const EXAMPLES = [
  "How many incidents at Site B last month?",
  "Show me overdue inspection actions by template",
  "Compare LTI rate this quarter vs last",
];

export default function EmptyState({ onSelectExample }) {
  return (
    <div className="h-full flex flex-col items-center justify-center px-6 text-center max-w-2xl mx-auto">
      <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-purple-500 flex items-center justify-center mb-5">
        <Sparkles className="w-6 h-6 text-white" strokeWidth={2} />
      </div>
      <h2 className="text-2xl font-semibold text-gray-900 mb-2 tracking-tight">
        Ask anything about your data
      </h2>
      <p className="text-sm text-gray-500 mb-8">
        Generate charts and analytics from your tenant's safety data.
      </p>
      <div className="w-full space-y-2">
        {EXAMPLES.map((ex, i) => (
          <button
            key={i}
            onClick={() => onSelectExample(ex)}
            className="w-full flex items-center justify-between px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm text-gray-700 hover:border-gray-300 hover:bg-gray-50 transition-colors group"
          >
            <span>{ex}</span>
            <ArrowRight className="w-4 h-4 text-gray-300 group-hover:text-gray-500 transition-colors" strokeWidth={2} />
          </button>
        ))}
      </div>
    </div>
  );
}
